// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6ac49f4b","513":"09d20ebc","703":"3814df36","787":"d493973a"}[chunkId] + ".chunk.js";
};